import { Button } from "@/components/ui/button";
import { MapPin, Clock, Phone } from "lucide-react";
import heroDish from "@/assets/esterno.webp";
import logo from "@/assets/armando-logo.png";

const HeroSection = () => {
  const scrollToContatti = () => {
    const element = document.getElementById("contatti");
    if (element) {
      // Calcola l'offset per tenere conto dell'header
      const headerHeight = 80; // h-20 = 80px
      const elementTop = element.offsetTop;
      const offsetPosition = elementTop - headerHeight - 20; // 20px extra di padding
      
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${heroDish})` }}
      >
        <div className="absolute inset-0 hero-gradient"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container-custom">
        <div className="max-w-4xl mx-auto text-center">
          <article>
            <div className="mb-6 flex flex-col items-center">
              <img
                src={logo}
                alt="Da Armando"
                width="1800"
                height="500"
                fetchPriority="high"
                className="h-24 sm:h-32 md:h-40 lg:h-48 w-auto"
              />
            </div>

            <p className="text-base sm:text-lg md:text-xl text-white/90 mb-6 max-w-2xl mx-auto">
              Cucina umbra autentica con vista mozzafiato sul Lago Trasimeno. Scopri i nostri piatti tradizionali preparati con ingredienti locali di qualità sulla nostra terrazza panoramica.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-8 justify-center">
              {/* Contenitore con overflow hidden per il pulsante */}
              <div className="overflow-hidden rounded-xl">
                <Button 
                  onClick={scrollToContatti}
                  className="relative bg-accent text-primary hover:bg-gold-hover text-lg px-6 sm:px-8 py-3 sm:py-4 rounded-xl font-semibold transform hover:scale-105 transition-all duration-300 shadow-lg w-full sm:w-auto group overflow-hidden"
                >
                  {/* Effetto brillante */}
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
                  
                  {/* Testo del pulsante */}
                  <span className="relative z-10">Prenota il tuo tavolo</span>
                </Button>
              </div>
              
              <div className="overflow-hidden rounded-xl">
                <Button 
                  variant="outline"
                  className="bg-white/10 text-white border-white/30 hover:bg-white/20 px-6 sm:px-8 py-3 sm:py-4 text-lg w-full sm:w-auto"
                  onClick={() => {
                    const element = document.getElementById("menu");
                    if (element) {
                      const headerHeight = 80;
                      const elementTop = element.offsetTop;
                      const offsetPosition = elementTop - headerHeight - 20;
                      
                      window.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth"
                      });
                    }
                  }}
                >
                  Scopri il Menu
                </Button>
              </div>
            </div>

            {/* Quick Info */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
              <address className="flex items-center space-x-3 text-white/90 not-italic">
                <MapPin className="text-gold flex-shrink-0" size={20} />
                <div>
                  <p className="font-semibold">Dove siamo</p>
                  <p className="text-sm text-white/70">Passignano sul Trasimeno, PG</p>
                </div>
              </address>

              <div className="flex items-center space-x-3 text-white/90">
                <Clock className="text-gold flex-shrink-0" size={20} />
                <div>
                  <p className="font-semibold">Orari</p>
                  <time className="text-sm text-white/70 block">Estate: 7/7 + Gio pomeriggio</time>
                  <time className="text-sm text-white/70 block">Inverno: 6/7 (Gio chiuso)</time>
                </div>
              </div>

              <div className="flex items-center space-x-3 text-white/90">
                <Phone className="text-gold flex-shrink-0" size={20} />
                <div>
                  <p className="font-semibold">Prenotazioni</p>
                  <p className="text-sm text-white/70">+39 075 388 0397</p>
                </div>
              </div>
            </div>
          </article>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white/60 rounded-full mt-2"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;